// extracted by mini-css-extract-plugin
export default {"section":"Footer_section__6AJgd","footerLink":"Footer_footerLink__xVufR","iconStyle":"Footer_iconStyle__47HUJ","copyrightTextStyle":"Footer_copyrightTextStyle__Yqc+I"};